module.exports = __webpack_public_path__ + "static/CALEFACCION-b012e7d5ee6fbc2e132cdfeeefbd0fbb.webp";